declare global {
    interface Window {
        TENANT_ID: string
        CUSTOMER_API: string
    }
}

export function getTenantName() : string {
    return window.TENANT_ID ?? "sirius2024"
}

export function getCustomerApi() : string {
	return window.CUSTOMER_API ?? "ui9rl0pnpnylgu8atuhfpdtisndmtzjwtupkjapob"
}
